<template>
	<div class="shippingCost">
		<el-dialog :title="ruleForm.id?'编辑运费':'新增运费'" :visible.sync="dialogVisible" width="60%" :before-close="onclose">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm"
				v-if="dialogVisible">
				<el-form-item label="渠道" prop="shop_id" v-if="!ruleForm.id">
					<el-select v-model="ruleForm.shop_id" placeholder="请选择渠道">
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="快递" prop="delivery_id" v-if="!ruleForm.id">
					<el-select v-model="ruleForm.delivery_id" placeholder="请选择快递" filterable>
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery" :key="k">
						</el-option>
					</el-select>
					<p class="myjg">如果选择相同的快递公司，会覆盖</p>
				</el-form-item>
				<el-form-item label="省份" prop="province" v-if="!ruleForm.id">
					<div>
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
							全选</el-checkbox>
					</div>
					<div>
						<el-checkbox-group v-model="ruleForm.province" @change="handleCheckedCitiesChange">
							<el-checkbox :label="v.label" name="type" v-for="(v,k) in sheng" :key="k">{{v.label}}
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</el-form-item>
				<el-form-item label="首重" prop="first_scale">
					<el-input v-model="ruleForm.first_scale"></el-input>
				</el-form-item>
				<el-form-item label="续重" prop="continue_scale">
					<el-input v-model="ruleForm.continue_scale"></el-input>
				</el-form-item>
				<el-form-item label="是否支持京东" prop="is_jd">
					<el-radio-group v-model="ruleForm.is_jd">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持淘宝" prop="is_taobao">
					<el-radio-group v-model="ruleForm.is_taobao">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持拼多多" prop="is_pdd">
					<el-radio-group v-model="ruleForm.is_pdd">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持抖店" prop="is_doudian">
					<el-radio-group v-model="ruleForm.is_doudian">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持得物" prop="is_dewu">
					<el-radio-group v-model="ruleForm.is_dewu">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="开关" prop="switch">
					<el-switch v-model="ruleForm.switch" :active-value="1" :inactive-value="2"></el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="支持的平台发货设置" :visible.sync="batchVisible" width="60%" :before-close="onclose1">
			<el-form :model="batchForm" ref="batchForm" label-width="150px" class="demo-ruleForm"
				v-if="batchVisible">
				<el-form-item label="渠道" prop="shop_id">
					<el-select v-model="batchForm.shop_id" placeholder="请选择渠道">
						<el-option label="全部" value=""></el-option>
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="快递" prop="delivery_id">
					<el-select v-model="batchForm.delivery_id" placeholder="请选择快递" filterable>
						<el-option label="全部" value=""></el-option>
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="是否支持京东" prop="is_jd">
					<el-radio-group v-model="batchForm.is_jd">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持淘宝" prop="is_taobao">
					<el-radio-group v-model="batchForm.is_taobao">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持拼多多" prop="is_pdd">
					<el-radio-group v-model="batchForm.is_pdd">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持抖店" prop="is_doudian">
					<el-radio-group v-model="batchForm.is_doudian">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否支持得物" prop="is_dewu">
					<el-radio-group v-model="batchForm.is_dewu">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="onsub1()">确定</el-button>
			</div>
		</el-dialog>

		<div class="btnbox">
			<el-button type="primary" size="small" @click="onbatch()">支持的平台发货设置</el-button>
			<el-button type="primary" size="small" @click="onadd()">新增运费</el-button>
			<el-button type="primary" size="small" @click="ondelall()">批量删除</el-button>
			<el-button type="primary" size="small" @click="onczall(1)">批量开启</el-button>
			<el-button type="primary" size="small" @click="onczall(2)">批量关闭</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.shop_id" placeholder="渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.delivery_id" placeholder="快递" filterable>
							<el-option label="快递" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.province" placeholder="省份">
							<el-option label="省份" value=""></el-option>
							<el-option :label="v.label" :value="v.label" v-for="(v,k) in sheng" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>

			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="50" align="center" header-align="center" fixed="left">
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" min-width="70px" fixed="left" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="delivery_name" label="快递公司" min-width="90px" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="province_name" label="省份" min-width="90px" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="first_scale" label="进货首重" min-width="60px" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="continue_scale" label="进货续重" min-width="60px" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="京东发货" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							{{scope.row.is_jd == 1?'支持':'不支持'}}
						</template>
					</el-table-column>
					<el-table-column label="淘宝发货" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							{{scope.row.is_taobao == 1?'支持':'不支持'}}
						</template>
					</el-table-column>
					<el-table-column label="拼多多发货" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							{{scope.row.is_pdd == 1?'支持':'不支持'}}
						</template>
					</el-table-column>

					<el-table-column label="抖店发货" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							{{scope.row.is_doudian == 1?'支持':'不支持'}}
						</template>
					</el-table-column>

					<el-table-column label="得物发货" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							{{scope.row.is_dewu == 1?'支持':'不支持'}}
						</template>
					</el-table-column>

					<el-table-column label="开关" align="center" header-align="center" min-width="50px">
						<template slot-scope="scope">
							{{scope.row.switch == 1?'开启':'关闭'}}
						</template>
					</el-table-column>

					<el-table-column label="操作" header-align="center" width="110px" align="center" fixed="right">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onmodify(scope.row)">编辑</span>
								<span @click="ondelete(scope.row.id)">删除</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]" :current-page.sync="page" :page-size="pageSize"
				:total="total" v-if="total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		name: 'shippingCost',
		data() {
			return {
				formfilter: {
					shop_id: "",
					delivery_id: "",
					province: "",
				},

				sheng: [],
				qudao: [],
				list: [],
				
				filtershow: true,
				page: 1,
				pageSize: 20,
				total: 0,

				dialogVisible: false,
				ruleForm: {
					id: "",
					shop_id: "",
					delivery_id: "",
					province: [],
					first_scale: 0,
					continue_scale: 0,
					is_jd: 0,
					is_taobao: 0,
					is_pdd: 0,
					is_doudian: 0,
					is_dewu: 0,
					switch: 1
				},

				checkAll: false,
				isIndeterminate: false,
				rules: {
					shop_id: [{
						required: true,
						message: '请选择渠道',
						trigger: 'change'
					}],

					delivery_id: [{
						required: true,
						message: '请选择快递',
						trigger: 'change'
					}],

					province: [{
						type: 'array',
						required: true,
						message: '请至少选择一个省份',
						trigger: 'change'
					}],
					first_scale: [{
						required: true,
						message: '首重不能为空'
					}, {
						pattern: /^\d+(\.\d{1,2})?$/,
						message: '格式不正确，请输入最多两位小数的数字',
						trigger: 'blur'
					}],

					continue_scale: [{
						required: true,
						message: '续重不能为空'
					}, {
						pattern: /^\d+(\.\d{1,2})?$/,
						message: '格式不正确，请输入最多两位小数的数字',
						trigger: 'blur'
					}]
				},
				
				batchVisible: false,
				batchForm: {
					shop_id: "",
					delivery_id: "",
					is_jd: 0,
					is_taobao: 0,
					is_pdd: 0,
					is_doudian: 0,
					is_dewu: 0
				},
				
				selectionArr: []
			}
		},

		inject: ['appdata'],

		mounted() {
			this.sdlist();
			this.onqudao();
			this.sheng = regionData;
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			sdlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/user/shop_delivery_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},


			onadd() {
				this.dialogVisible = true;
			},

			onmodify(obj) {
				for (let key in this.ruleForm) {
					// if (key == "continue_scale" || key == "first_scale") {
					// 	this.ruleForm[key] = Number(obj[key].split(".")[0]);
					// } else {
					// 	this.ruleForm[key] = obj[key];
					// }
					this.ruleForm[key] = obj[key];
					
				}

				this.dialogVisible = true;
			},

			handleCurrentChange() {
				this.sdlist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.sdlist();
			},

			onfilter() {
				this.page = 1;
				this.sdlist();
			},

			onreset() {
				this.page = 1;
				this.formfilter = {
					shop_id: "",
					delivery_id: "",
					province: "",
				};
				this.sdlist();
			},

			onclose() {
				this.dialogVisible = false;
				this.checkAll = false;
				this.isIndeterminate = false;
				this.ruleForm = {
					id: "",
					shop_id: "",
					delivery_id: "",
					province: [],
					first_scale: 0,
					continue_scale: 0,
					is_jd: 0,
					is_taobao: 0,
					is_pdd: 0,
					is_doudian: 0,
					is_dewu: 0,
					switch: 1
				};
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						if (!this.ruleForm.id) {
							obj.province = obj.province.join(',');
						}
						this.$axios.post('api/user/shop_delivery_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('提交成功');
								this.onclose();
								this.sdlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			handleCheckAllChange(val) {
				this.isIndeterminate = false;
				if (val) {
					this.sheng.forEach((v, k) => {
						this.ruleForm.province.push(v.label);
					})
				} else {
					this.ruleForm.province = [];
				}
			},

			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.sheng.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.sheng.length;
			},
			
			ondelete(id) {
				this.$confirm('是否删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						ids: id,
					}
					this.$axios.post('api/user/shop_delivery_delete', data).then(res => {
						if (res.data.code == 0) {
							this.$message.success('删除成功');
							this.sdlist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},
			
			onbatch() {
				this.batchVisible = true;
			},
			
			onclose1 () {
				this.batchVisible = false;
				this.batchForm = {
					shop_id: "",
					delivery_id: "",
					is_jd: 0,
					is_taobao: 0,
					is_pdd: 0,
					is_doudian: 0,
					is_dewu: 0
				};
			},
			
			onsub1(){
				this.$refs['batchForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.batchForm));
						this.$axios.post('api/user/shop_delivery_set', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('提交成功');
								this.onclose1();
								this.sdlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			handleSelectionChange(val) {
				this.selectionArr = val;
			},
			
			onids() {
				var arr = [];
				this.selectionArr.forEach((v, k) => {
					arr.push(v.id);
				})
			
				return arr.join(',')
			},
			
			ondelall() {
				if (this.selectionArr && this.selectionArr.length == 0) {
					this.$message.warning('请先勾选您要操作的数据');
					return;
				}
				
				var text = '是否删除选中的' + this.selectionArr.length + '条数据';
				this.$confirm(text, '是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						ids: this.onids(),
					}
					this.$axios.post('api/user/shop_delivery_delete', data).then(res => {
						if (res.data.code == 0) {
							this.$message.success('删除成功');
							this.sdlist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},
			
			onczall(n) {
				if (this.selectionArr && this.selectionArr.length == 0) {
					this.$message.warning('请先勾选您要操作的数据');
					return;
				}
				var nn = n==1?'开启':'关闭';
				var text = '是否'+nn+'选中的' + this.selectionArr.length + '条数据';
				this.$confirm(text, '是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						ids: this.onids(),
						switch: n
					}
					this.$axios.post('api/user/shop_delivery_set_switch', data).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.sdlist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.shippingCost {
		height: 100%;
	}
	.tablebox {
		height: calc(100% - 104px);
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/shippingCost.vue